import React, { useState, useEffect } from 'react';
import ConfirmLinkModal from './ConfirmLinkModal.jsx';

const DataSelectionModal = ({ isOpen, onClose, onSuccess, checkData, username, password }) => {
    const [subscription, setSubscription] = useState('telegram');
    const [completedLessons, setCompletedLessons] = useState('telegram');
    const [profile, setProfile] = useState('telegram');
    const [showConfirm, setShowConfirm] = useState(false);

    const telegramData = checkData?.telegramData || {};
    const webData = checkData?.webData || {};

    const telegramHasSubscription = telegramData.expireDate && new Date(telegramData.expireDate) > new Date();
    const webHasSubscription = webData.expireDate && new Date(webData.expireDate) > new Date();

    useEffect(() => {
        if (!checkData) return;

        if (telegramHasSubscription && !webHasSubscription) {
            setSubscription('telegram');
        } else if (webHasSubscription && !telegramHasSubscription) {
            setSubscription('web');
        } else if (telegramHasSubscription && webHasSubscription) {
            setSubscription('telegram');
        } else {
            setSubscription('telegram');
        }
    }, [checkData, telegramHasSubscription, webHasSubscription]);

    if (!isOpen || !checkData) return null;

    const handleContinue = () => {
        setShowConfirm(true);
    };

    const handleConfirmClose = () => {
        setShowConfirm(false);
    };

    const handleConfirmSuccess = () => {
        setShowConfirm(false);
        onSuccess();
    };

    if (showConfirm) {
        return (
            <ConfirmLinkModal
                isOpen={true}
                onClose={handleConfirmClose}
                onSuccess={handleConfirmSuccess}
                dataSelection={{
                    subscription,
                    completedLessons,
                    profile
                }}
                checkData={checkData}
                username={username}
                password={password}
            />
        );
    }

    const subscriptionDisabled = (telegramHasSubscription && !webHasSubscription) ||
        (webHasSubscription && !telegramHasSubscription);

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content modal-content-large" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Выберите данные для сохранения</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <div className="data-selection-section">
                        <h3>Подписка</h3>
                        <div className="toggle-group">
                            <label className={`toggle-option ${subscription === 'telegram' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="subscription"
                                    value="telegram"
                                    checked={subscription === 'telegram'}
                                    onChange={(e) => setSubscription(e.target.value)}
                                    disabled={subscriptionDisabled && !telegramHasSubscription}
                                />
                                <span>Telegram</span>
                                {telegramHasSubscription && (
                                    <span className="data-info">До {new Date(telegramData.expireDate).toLocaleDateString()}</span>
                                )}
                                {!telegramHasSubscription && <span className="data-info">Нет подписки</span>}
                            </label>
                            <label className={`toggle-option ${subscription === 'web' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="subscription"
                                    value="web"
                                    checked={subscription === 'web'}
                                    onChange={(e) => setSubscription(e.target.value)}
                                    disabled={subscriptionDisabled && !webHasSubscription}
                                />
                                <span>Веб</span>
                                {webHasSubscription && (
                                    <span className="data-info">До {new Date(webData.expireDate).toLocaleDateString()}</span>
                                )}
                                {!webHasSubscription && <span className="data-info">Нет подписки</span>}
                            </label>
                        </div>
                    </div>

                    <div className="data-selection-section">
                        <h3>Пройденные уроки</h3>
                        <div className="toggle-group">
                            <label className={`toggle-option ${completedLessons === 'telegram' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="completedLessons"
                                    value="telegram"
                                    checked={completedLessons === 'telegram'}
                                    onChange={(e) => setCompletedLessons(e.target.value)}
                                />
                                <span>Telegram</span>
                                <span className="data-info">{telegramData.completedLessonsCount || 0} уроков</span>
                            </label>
                            <label className={`toggle-option ${completedLessons === 'web' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="completedLessons"
                                    value="web"
                                    checked={completedLessons === 'web'}
                                    onChange={(e) => setCompletedLessons(e.target.value)}
                                />
                                <span>Веб</span>
                                <span className="data-info">{webData.completedLessonsCount || 0} уроков</span>
                            </label>
                        </div>
                    </div>

                    <div className="data-selection-section">
                        <h3>Данные профиля</h3>
                        <div className="toggle-group">
                            <label className={`toggle-option ${profile === 'telegram' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="profile"
                                    value="telegram"
                                    checked={profile === 'telegram'}
                                    onChange={(e) => setProfile(e.target.value)}
                                />
                                <span>Telegram</span>
                                <span className="data-info">
                                    {telegramData.profile?.name || 'Аноним'},
                                    {telegramData.profile?.totalLessonScore || 0} баллов
                                </span>
                            </label>
                            <label className={`toggle-option ${profile === 'web' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="profile"
                                    value="web"
                                    checked={profile === 'web'}
                                    onChange={(e) => setProfile(e.target.value)}
                                />
                                <span>Веб</span>
                                <span className="data-info">
                                    {webData.profile?.name || 'Аноним'},
                                    {webData.profile?.totalLessonScore || 0} баллов
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="modal-actions">
                    <div className="actions-group">
                        <button
                            type="button"
                            className="primary-action"
                            onClick={handleContinue}
                        >
                            Продолжить
                        </button>
                        <button
                            type="button"
                            className="ghost-action"
                            onClick={onClose}
                        >
                            Отмена
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataSelectionModal;

